import React from "react"
import { graphql } from "gatsby"
import Helmet from 'react-helmet'
import Layout from "../components/Layout/layout"
import { WhyAutifyHeader, Trust, CustomerStories } from "../components"
import SkewBgHeader from "../components/common/SkewBgHeader/SkewBgHeader"

function WhyAutify({
  pageContext: { language },
  location,
  data: {
    dataYaml: { whyAutify, common, meta },
    allMarkdownRemark: { edges: stories },
    allFile: { nodes: trustedCompanyLogos },
  },
}) {
  return (
    <Layout location={location} title={common.nav.why.text} description={meta.whyAutify.description}>
      <Helmet>
        <meta property="og:type" content="article" />
      </Helmet>
      <SkewBgHeader marginTop={true} skewBgColor="green" bottomBgColor="gray" background="white" topBgColor="white">
        <WhyAutifyHeader language={language} hero={whyAutify.hero} />
      </SkewBgHeader>
      <Trust language={language} trust={whyAutify.trust} trustedCompanyLogos={trustedCompanyLogos} />
      <CustomerStories
        language={language}
        stories={stories}
        title={whyAutify.customerStories.title}
      />
    </Layout>
  )
}

export const query = graphql`
  query($language: String, $contentPath: String) {
    allMarkdownRemark(filter: { fileAbsolutePath: { regex: $contentPath } }) {
      edges {
        node {
          id
          frontmatter {
            slug
            company
            interviewee
            date(formatString: "ll")
            title
            image {
              childImageSharp {
                fluid(maxWidth: 400) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
            logo {
              name
              publicURL
            }
          }
        }
      }
    }
    dataYaml(language: { eq: $language }) {
      common {
        nav {
          why {
            text
          }
        }
      }
      whyAutify {
        customerStories {
          title
        }
        hero {
          title
          description
        }
        trust {
          title
        }
      }
      meta {
        whyAutify {
          description
          title
        }
      }
    }
    allFile(filter: {relativePath: {glob: "customer_logos/*"}}, sort: {fields: name}) {
      nodes {
        name
        publicURL
      }
    }
  }
`

export default WhyAutify
